import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: import.meta.env.PUBLIC_SENTRY_DSN || "",
  environment: import.meta.env.PUBLIC_ENVIRONMENT || "local",
  enabled: import.meta.env.PUBLIC_ENVIRONMENT === "production",
  tracesSampleRate: 0.1,
});
